import type { BlockManifest } from '@template-ui/blocks';

/** Automatic subject resolution is part of the retained named view, never staff configuration. */
export const caseSnapshotBlock: BlockManifest = {
  provider: 'phms',
  code: 'case.snapshot',
  version: 1,
  name: 'Case snapshot',
  description:
    'Compact hearing, identity essentials and custody context for the workflow’s subject.',
  category: 'Domain information',
  keywords: ['case', 'snapshot', 'hearing', 'custody'],
  contextNeeds: ['workflowInstanceId', 'stepOccurrenceId'],
  reads: [
    {
      code: 'case.snapshot',
      version: 1,
      parameterContract: { code: 'case.snapshot.parameters', version: 1 },
      dataContract: { code: 'case.snapshot.result', version: 1 },
      parameters: { occurrenceId: 'stepOccurrenceId' },
    },
  ],
  settingsSchema: { code: 'case.snapshot.settings', version: 1, fields: {} },
  placements: [
    { host: 'step-shell', region: 'main' },
    { host: 'step-shell', region: 'supporting' },
  ],
  layout: {
    widths: ['full', 'half'],
    minimumWidthPx: 280,
    minimumHeightPx: 120,
    responsive: 'stack-in-order',
  },
  instances: 'single-per-workspace',
};
